import React from 'react';
import cn from 'classnames';
import { Icon } from '@landing/ui';
import * as styles from './Contacts.module.scss';

function Contacts() {
  return (
    <>
      <a href="https://andersenlab.com/" target="_blank" rel="noreferrer" className={styles.link}>
        <Icon name="globe" className={styles.icon} />
        <span className={styles.phone}>andersenlab.com</span>
      </a>
      <a href="mailto:vn@andersenlab.com" className={cn(styles.link, styles.linkEmail)}>
        <Icon name="mail" className={styles.icon} />
        <span className={styles.mail}>vn@andersenlab.com</span>
      </a>
    </>
  );
}

export default Contacts;
